export default {
	data() {
		return {
			assetFieldRegistry: {},
			assetFieldValidity: {}
		}
	},

	provide() {
		return {
			registerAssetField: this.registerAssetField,
			unregisterAssetField: this.unregisterAssetField,
			setAssetFieldValidity: this.setAssetFieldValidity,
			assetFieldValidity: this.assetFieldValidity,
		}
	},

	methods: {
		// Asset componenten (Pictures, AssetableTable) met assetable-type/group props registreren
		// zich hier. Geregistreerde velden worden uit de initiële POST gehouden en pas na de
		// save van het model opgeslagen via de assets API.
		registerAssetField(field) {
			this.assetFieldRegistry[field.name] = field;
		},

		unregisterAssetField(name) {
			delete this.assetFieldRegistry[name];
			delete this.assetFieldValidity[name];
		},

		// Asset componenten melden hier hoeveel bestanden nog verplichte metadata missen.
		// FormButtons injecteert assetFieldValidity en blokkeert het opslaan zolang er
		// velden zijn met ontbrekende verplichte metadata.
		setAssetFieldValidity(name, missingCount) {
			if (missingCount > 0) {
				this.assetFieldValidity[name] = missingCount;
			} else {
				delete this.assetFieldValidity[name];
			}
		},

		getAssetFieldNames() {
			return Object.keys(this.assetFieldRegistry);
		},

		stripAssetFields(data) {
			this.getAssetFieldNames().forEach((name) => delete data[name]);
			return data;
		},

		// Slaat na de save van het model alle asset-velden op via de assets API.
		// Gaat bij een fout door met het volgende bestand en geeft de mislukte bestanden terug.
		async syncAssetFields(form, modelId) {
			let failed = [];
			if (!modelId) {
				return failed;
			}

			for (let name of this.getAssetFieldNames()) {
				let registration = this.assetFieldRegistry[name];
				let items = form[name];
				if (!registration || !Array.isArray(items)) {
					continue;
				}

				failed.push(...await this.deleteAssets(items));
				failed.push(...await this.storeAssets(items, registration, modelId));
				await this.syncAssetPrios(items, registration, modelId);
			}

			return failed;
		},

		async deleteAssets(items) {
			let toDelete = items.filter((item) => item.deleted && item.id);
			if (!toDelete.length) {
				return [];
			}

			try {
				await this.assetRequest(route('api.v1.assets.deleteByBulk'), 'DELETE', {
					ids: toDelete.map((item) => item.id)
				});
				return [];
			} catch (xhr) {
				return toDelete.map((item) => ({
					title: item.title ?? item.name,
					message: this.assetErrorMessage(xhr)
				}));
			}
		},

		async storeAssets(items, registration, modelId) {
			let failed = [];
			for (let item of items.filter((item) => !item.deleted)) {
				try {
					if (!item.id) {
						let response = await this.assetRequest(
							route('api.v1.assets.store'),
							'POST',
							this.buildAssetPayload(item, registration, modelId)
						);
						item.id = response.asset?.id;
					} else if (item.dirty) {
						await this.assetRequest(
							route('api.v1.assets.update', {asset: item.id}),
							'PUT',
							this.buildAssetPayload(item, registration, modelId)
						);
						item.dirty = false;
					}
				} catch (xhr) {
					failed.push({
						title: item.title ?? item.name,
						message: this.assetErrorMessage(xhr)
					});
				}
			}
			return failed;
		},

		// De volgorde van het veld is leidend; de prio's worden hierop gelijkgezet
		async syncAssetPrios(items, registration, modelId) {
			let objects = {};
			items.filter((item) => !item.deleted && item.id).forEach((item, index) => objects[item.id] = index);
			if (!Object.keys(objects).length) {
				return;
			}

			try {
				await this.assetRequest(route('api.v1.assets.updateprio'), 'POST', {
					assetable_type: registration.assetableType,
					assetable_id: modelId,
					objects: objects
				});
			} catch (xhr) {
				console.error('Bijwerken van de volgorde is mislukt', xhr);
			}
		},

		buildAssetPayload(item, registration, modelId) {
			return {
				assetable_type: registration.assetableType,
				assetable_id: modelId,
				assetable_group: registration.assetableGroup,
				title: item.title ?? item.name,
				metadata: item.metadata ?? {},
				base64: item.base64 ? {
					base64: item.base64,
					name: item.name,
					size: item.size,
					type: item.type,
					lastModified: item.lastModified
				} : null
			}
		},

		assetRequest(url, method, data) {
			return new Promise((resolve, reject) => {
				$.ajax({
					url: url,
					method: method,
					contentType: 'application/json',
					processData: false,
					data: JSON.stringify(data),
					success: resolve,
					error: reject
				});
			});
		},

		assetErrorMessage(xhr) {
			let response = xhr?.responseJSON;
			if (response?.message) {
				return response.message;
			}
			if (response?.errors) {
				return Object.values(response.errors).flat().join(' ');
			}
			return 'Het bestand kon niet worden opgeslagen.';
		},

		getFailedAssetsMessage(failed) {
			let titles = failed.map((file) => `'${file.title}'`).join(', ');
			return `De gegevens zijn opgeslagen, maar de volgende bestanden konden niet worden opgeslagen: ${titles}. Voeg deze opnieuw toe en sla nogmaals op.`;
		}
	}
}
